<div class="d-none d-sm-none d-md-block ">
	<app-logo-toolbar></app-logo-toolbar>
</div>
<div class="d-block d-sm-block d-md-none">
	<mat-toolbar color="primary" class="shadow mb-1">
		  <div class="col-1 p-0 ml-2">
			<span (click)="stepOn()">
			  <fa-icon [icon]="faArrowLeft" class="fa-solid"></fa-icon>
			</span>
  
		  </div>
		  <div class="col-11 d-flex justify-content-center p-0">
			<span> {{ 'TRACING_PAGE.LABEL1' | translate }} </span>
		  </div>
	</mat-toolbar>
  
  </div>
  
  <app-info-toolbar></app-info-toolbar>
  <app-spinner *ngIf="loading"></app-spinner>
  <div class="container-fluid" *ngIf="tracking">
	  <div class="row containerRow">
		<div class="col-3 d-none d-sm-none d-md-block">
		  <div class="row">
			<div class = "col">
				<app-breadcrumb></app-breadcrumb>
			</div>
		  </div>
		  <div class="row d-none d-sm-none d-md-block mb-2">
			<div class="col">
			  <span class="serviceTitle"> {{ 'TRACING_PAGE.LABEL2' | translate }} </span>
			</div>
		  </div>
		  <div class="row">
			<div class="d-none d-sm-none d-md-block col-12 col " >
			  <app-side-menu ></app-side-menu>
			</div>
		  </div>
		</div>
		<div class="col-sm-12 col-md-9 p-0">
			<div class="container-fluid">
				<div class="row m-2">
					<div class="col-12">
						<mat-card>
							<mat-card-content>
								{{ 'TRACING_PAGE.LABEL3' | translate }}  <span class="hightText">{{tracking.ClaimNumber}}</span>
							</mat-card-content>
						</mat-card>
					</div>
				</div>

				<div class="row m-2">
					<div class="col-12">
						<mat-card>
							<mat-card-content>
								<app-device-view [device]="device" [msspItem]="msspItem" [singleDevice]="true">
								</app-device-view>
							</mat-card-content>
						</mat-card>
					</div>
				</div>

				<div class="row m-2">
					<div class="">
						<div class="row justify-content-md-center">
							<div id="step" class="process" [ngClass]="{'col-md-8': tracking.ClosedDate, 'col-md-12': !tracking.ClosedDate }">
								<mat-card>
									<mat-card-content>
										<ul>
											<li *ngIf="tracking.CreatedDate" class="step">
												<div class='title tracking_color'>
													<p class="fs-5"> {{ 'TRACING_PAGE.LABEL4' | translate }} </p>
												</div>
												<div class="name">
													<div class='info'>
														<p class="hightText text-muted align-items-stretch fs-6">
															{{ 'TRACING_PAGE.LABEL5' | translate }} 
														</p>
														<p> {{tracking.CreatedDate | date: 'dd/MM/yyyy'}} </p>
													</div>
													
													<div class='info'>
														<p class="hightText text-muted align-items-stretch fs-6" *ngIf="tracking.ClaimStatus == 'P'">
															{{ 'TRACING_PAGE.LABEL6' | translate }} 
														</p>

														<p class="hightText text-muted align-items-stretch fs-6" *ngIf="tracking.ClaimStatus == 'D'">
															{{ 'TRACING_PAGE.LABEL7' | translate }} 
														</p>
														<p class="hightText text-muted align-items-stretch fs-6" *ngIf="tracking.ClaimStatus == 'A'">
															{{ 'TRACING_PAGE.LABEL8' | translate }} 
														</p>
														<p class="hightText text-muted align-items-stretch fs-6" *ngIf="tracking.ClaimStatus == 'C'">
															{{ 'TRACING_PAGE.LABEL9' | translate }} 
														</p>
														<p *ngIf="tracking.ClaimStatus == 'D' || tracking.ClaimStatus == 'P'">{{tracking.ClosedDate | date: 'dd/MM/yyyy'}}</p>
														<p *ngIf="tracking.ClaimStatus == 'A'|| tracking.ClaimStatus == 'C'">{{tracking.ClaimApprovalDate ? (tracking.ClaimApprovalDate | date: 'dd/MM/yyyy') : tracking.ClosedDate  | date: 'dd/MM/yyyy'}}</p>
												
													</div>

												</div>

											</li>
											<li class="step" *ngIf="tracking.ClaimStatus != 'D' || tracking.ClaimStatus != 'P'">
												<div class="name">
													<div class='title tracking_color'>
														<p class="fs-5"> {{ 'TRACING_PAGE.LABEL10' | translate }} </p>
													</div>
													<div *ngFor="let extended of sortBy('StatusDate')" class='info'>
														<p class="hightText text-muted align-items-stretch fs-6">
															{{extended.StatusDescription}} 
														</p>
														<p>{{extended.StatusDate | date: 'dd/MM/yyyy'}}</p>

													</div>


												</div>
											</li>
											<li *ngIf="tracking.ClosedDate" class="step">
												<div class="name">
													<div class='title tracking_color'>
														<p class="fs-5"> {{ 'TRACING_PAGE.LABEL11' | translate }} </p>
													</div>
													<div class='info'>
														<p class="hightText text-muted align-items-stretch fs-6">
															{{ 'TRACING_PAGE.LABEL12' | translate }} 
														</p>
														<p> {{tracking.ClosedDate | date: 'dd/MM/yyyy'}} </p>
													</div>
												</div>
											</li>
										</ul>
										<div *ngIf="tracking.ClosedDate && tracking.ExtendedStatus > 2">
											{{ 'TRACING_PAGE.LABEL13' | translate }}  <br>  {{ 'TRACING_PAGE.LABEL14' | translate }} 
										</div>
									</mat-card-content>
								</mat-card>
								<div class="d-none d-sm-none d-md-flex justify-content-end mt-4 col-12">
									<button class="w-25 p-1" type="button" (click)="stepOn()" mat-raised-button color="accent"> {{ 'TRACING_PAGE.LABEL15' | translate }} </button>
								</div>
							</div>
							<div *ngIf="tracking.ClosedDate" id="calendar"  class="col-md-4 d-block">
								<mat-card>
									<mat-card-content>
										<div class='border border-ligth calendarcard m-3 p-4'>
											<div style="display: flex;width: 150px;margin: auto;">
												<div class="circle border border-secondary rounded-circle"> </div>
												<div class="circle border border-secondary rounded-circle"> </div>
											</div>
											<div>
												<h4 class='primary-color text-center'> {{ 'TRACING_PAGE.LABEL16' | translate }} 
												</h4>
											</div>
											<div class="">
												<div style="width: 150px; margin: auto;">
													<div style="display: flex;">
														<div  *ngFor="let number of output"
															class='col border border-2 border-ligth rounded number_text text-center muted-color'>
															{{ number}}
														</div>
														
													</div>
												</div>
											</div>
										
											<div>
												<span class='muted-color-3 text-center'>
													<h2> {{ 'TRACING_PAGE.LABEL17' | translate }} </h2>
												</span>
											</div>
											<div class="muted-color-3 text-center">
												{{ 'TRACING_PAGE.LABEL18' | translate }}  <span class='primary-color'>
													{{ 'TRACING_PAGE.LABEL19' | translate }} 
												</span>
												{{ 'TRACING_PAGE.LABEL20' | translate }} 
											</div>
										</div>
									</mat-card-content>
								</mat-card>
							</div>
						</div>
					</div>
				</div>
				<div class="row m-0">
					<div class="d-block d-sm-block d-md-none w-100">
						<mat-card class="serviceCard my-3">
							<mat-card-content>
								<button class="w-100 p-1 mx-2" type="button" (click)="stepOn()" mat-raised-button color="accent"> {{ 'TRACING_PAGE.LABEL21' | translate }} </button>
							</mat-card-content>
						</mat-card>
					</div>
				</div>
			</div>
		</div>
	</div>
	<br><br>
	<!-- <app-whatsapp></app-whatsapp> -->
	<app-footer></app-footer>
</div>